export default "__VITE_ASSET__CALRjcHa__"